<template>
<div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Almacén</span>
    <div class="filter-colum-sections">
      <v-text-field
        style="width: 320px;"
        type="text"
        placeholder="Buscar"
        v-model="currentSearch"
        color="#222222"
        variant="underlined">
        <template v-slot:append-inner>
          <v-icon color="#222222" icon="mdi-magnify" size="small"/>
        </template>
      </v-text-field>
    </div>
  </div>
    <div class="select-filter-container">
      <div>
        <span class="title-filter">De </span>
        <!--date start picker-->
        <v-dialog v-model="showPS" max-width="330">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props"
            color="#FF5700"
            variant="text">
              {{dateStartFormatted}}
            </v-btn>
          </template>
          <v-card>
            <v-date-picker
              v-model="dateStart"
              type="date"
              :allowed-dates="allowedPastDates"
              hide-header
              hide-actions
              locale="es"
              @update:model-value="onDateStartSelected"/>
          </v-card>
        </v-dialog>
        <!--end date start-->
        <span class="title-filter"> a </span>
        <!-- date end picker-->
        <v-dialog v-model="showPE" max-width="330">
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props"
            color="#FF5700"
            variant="text">
              {{dateEndFormatted}}
            </v-btn>
          </template>
          <v-card>
            <v-date-picker
              v-model="dateEnd"
              type="date"
              :allowed-dates="allowedPastDates"
              hide-header
              hide-actions
              locale="es"
              @update:model-value="onDateEndSelected"/>
          </v-card>
        </v-dialog>
        <!--end date end-->
      </div>

      <div class="select-filter-container-right">
        <v-btn
          append-icon="mdi-download"
          variant="text"
          style=" margin-right: 20px;"
          color="#FF5700"
          @click="exportExcel">
            Descargar Registros
        </v-btn>

        <span class="title-filter">Tipo:</span>
        <v-select
          style="max-width: 120px;"
          density="compact"
          hide-details="auto"
          variant="solo"
          class="no-bg"
          v-model="filterTypeSelected"
          :items="filterType"
          item-title="text"
          item-value="value">
        </v-select>

        <div class="autocomplete-container">
          <span class="title-filter">POS:</span>
          <v-select
            v-model="filterSelected"
            :items="filterData"
            item-title="label"
            item-value="value"
            density="compact"
            hide-details="auto"
            variant="solo"
            class="no-bg"/>
        </div>
      </div>
    </div>

    <stock-table :stock="stock" @refreshList="getList"/>

    <div v-if="totalPages > page"
      class="container-btn-more">
      <button class="btn-text" @click="moreData">
        + Mostrar más
      </button>
    </div>

    <div class="fab-button" @click="addModal">
      <v-icon icon="mdi-plus"></v-icon>
    </div>

    <add-edit-stock
    ref="addEditModal"
    @refreshList="getList"
    :terminals="filterData"/>

</div>
</template>
<script>
import terminalsApi from '@/api/terminalsApi'
import dateTransform from '@/utils/dateTransform'
import StockTable from '../tables/StockTable.vue'
import stockApi from '@/api/stockApi'
import AddEditStock from '../forms/AddEditStock.vue'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  name: 'CommerciaVueStock',
  components: {
    StockTable,
    AddEditStock
  },
  data () {
    return {
      dateStart: new Date(new Date().setDate(new Date().getDate() - 3)),
      showPS: false,
      dateEnd: new Date(),
      showPE: false,
      business: this.$store.getters.business,
      currentSearch: '',
      filterSelected: 'all',
      filterData: [{ value: 'all', label: 'Todos' }],
      filterTypeSelected: 'all',
      filterType: [
        { value: 'all', text: 'Todos' },
        { value: 'in', text: 'Entrada' },
        { value: 'out', text: 'Salida' }
      ],
      stock: [],
      page: 1,
      totalPages: 0
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    dateStartFormatted () {
      return dateTransform.formatInput(this.dateStart)
    },
    dateEndFormatted () {
      return dateTransform.formatInput(this.dateEnd)
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance') {
      this.$router.push({ name: 'dashboard' })
    }
    this.getList()
    this.getPos()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    filterTypeSelected (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateStart (newVal, oldVal) {
      this.page = 1
      this.getList()
    },
    dateEnd (newVal, oldVal) {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    moreData () {
      this.page += 1
      this.getList()
    },
    addModal () {
      this.$refs.addEditModal.add()
    },
    clearSearch () {
      this.page = 1
      this.currentSearch = ''
      this.getList()
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    },
    async getList () {
      if (this.filterSelected === 'all') {
        console.log('getList')
        const dataResponse = await stockApi.listByBussines(
          this.business._id,
          this.currentSearch,
          this.page,
          dateTransform.timetoApi(this.dateStart),
          dateTransform.timetoApi(this.dateEnd),
          this.filterTypeSelected,
          20)
        console.log('list by business', dataResponse.data)
        this.stock = this.page === 1
          ? (dataResponse.data || [])
          : [...this.stock, ...(dataResponse.data || [])]
        console.log(this.stock)
        this.totalPages = dataResponse.totalPages || 0
      } else {
        const dataResponse = await stockApi.listByPos(
          this.filterSelected,
          this.currentSearch,
          this.page,
          dateTransform.timetoApi(this.dateStart),
          dateTransform.timetoApi(this.dateEnd),
          this.filterTypeSelected,
          20)
        this.stock = this.page === 1
          ? (dataResponse.data || [])
          : [...this.stock, ...(dataResponse.data || [])]
        this.totalPages = dataResponse.totalPages || 0
      }
    },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormatExcel(timestamp)
    },
    async exportExcel () {
      let dataResponse
      if (this.filterSelected === 'all') {
        dataResponse = await stockApi.listByBussinesExcel(
          this.business._id,
          this.currentSearch,
          this.page,
          dateTransform.timetoApi(this.dateStart),
          dateTransform.timetoApi(this.dateEnd),
          this.filterTypeSelected,
          10000)
      } else {
        dataResponse = await stockApi.listByPosExcel(
          this.filterSelected,
          this.currentSearch,
          this.page,
          dateTransform.timetoApi(this.dateStart),
          dateTransform.timetoApi(this.dateEnd),
          this.filterTypeSelected,
          10000)
      }
      console.log('data : ', dataResponse)
      const dataStockExcel = []
      dataStockExcel.push(['CREADO', 'FOLIO', 'TIPO', 'SKU', 'ELIMINADO', 'PRODUCTO',
        'UNIDADES', 'COSTO UNITARIO', 'TOTAL ($)', 'RECIBIÓ', 'POS', 'NOTA'])

      for (const item of dataResponse.data) {
        const dateItem = this.formatTimestamp(item.createdAt)
        const importUnit = (item.cost / item.quantity).toFixed(2)
        dataStockExcel.push([
          dateItem,
          item.folio,
          item.type === 'in' ? 'Entrada' : 'Salida',
          item.product_sku,
          item.deleted ? 'Sí' : 'No',
          item.product_name,
          item.quantity,
          importUnit,
          item.cost,
          item.receives,
          item.terminal_id.name || '',
          item.note
        ])
      }

      const workbook = XLSX.utils.book_new()
      const name = dateTransform.formatInput(this.dateStart) +
      ' al ' +
      dateTransform.formatInput(this.dateEnd)

      const data = XLSX.utils.aoa_to_sheet(dataStockExcel)
      const boock = 'Stock'
      XLSX.utils.book_append_sheet(workbook, data, boock)

      XLSX.writeFile(workbook, `Registros E/S ${name}.xlsx`)
    },
    onDateStartSelected (newDate) {
      this.dateStart = newDate
      this.showPS = false
    },
    onDateEndSelected (newDate) {
      this.dateEnd = newDate
      this.showPE = false
    },
    allowedPastDates (date) {
      const today = new Date()
      return date <= today
    },
    onClearFilter () {
      this.filterSelected = 'all'
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
</style>
